import { render, staticRenderFns } from "./Graph2D.vue?vue&type=template&id=6b4c647c&scoped=true&"
import script from "./Graph2D.vue?vue&type=script&lang=js&"
export * from "./Graph2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c647c",
  null
  
)

export default component.exports